import { Delete, Visibility } from "@material-ui/icons";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbar } from '@mui/x-data-grid-premium';
import { useState } from "react";
import { Button, } from "react-bootstrap";
import { useDeleteInterlinersMutation, useGetInterlinerAgentQuery } from "../../../features/Interliners/InterlinersFieldsSlice";
import Spinner from "../../Spinner";

export default function InterlinersList({
    getInterlinerRowData, openEditForm, interlinerRowData }) {
    const { data: interlinerList, isLoading, refetch } = useGetInterlinerAgentQuery()
    const [deleteInterliners] = useDeleteInterlinersMutation()
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState("")
    const handleClose = async () => { await deleteInterliners(deleteId); refetch(); setOpen(false); };

    if (!interlinerList && isLoading) return <><Spinner /></>;

    const columns = [
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            width: 120,
            disableClickEventBubbling: true,
            renderCell: (data) => {
                const onClick = async (e) => {
                    e.stopPropagation();
                    await getInterlinerRowData(data?.id)
                    openEditForm()
                };
                const onRemove = (e) => {
                    setDeleteId(data.id)
                    setOpen(true)
                };

                return (
                    <>
                        <div className="action_btn">
                            <span className="view_btn" onClick={onClick}><Visibility /></span>
                            <span className="del_btn" onClick={onRemove}><Delete /></span>
                        </div>
                        <div>
                            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                                <DialogTitle id="alert-dialog-title">
                                    Delete Confirmation
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete this row?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button className="btn-secondary" onClick={() => { setOpen(false); }}>Cancel</Button>
                                    <Button className="btn-primary" onClick={() => { handleClose() }} autoFocus> Confirm</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </>
                )
            },
        },
        { field: "switchTypename", headerName: "Type", width: 120 },
        { field: "driverNumber", headerName: "Driver Number", width: 140 },
        { field: "alphaCode", headerName: "Code", width: 120 },
        { field: "companyName", headerName: "Company Name", width: 160 },
        { field: "city", headerName: "City", width: 120 },
        { field: "province", headerName: "Province", width: 120 },
        { field: "country", headerName: "Country", width: 120 },
        { field: "primarynumber", headerName: "Primary Number", width: 150 },
        { field: "email", headerName: "Email", width: 160 },
        { field: "payCycle", headerName: "Pay Cycle", width: 120 },
        { field: "dockName", headerName: "Dock", width: 120 },
    ];
    const rows = interlinerList?.data?.map((data) => {
        return {
            id: data?.interlinersId,
            payNo: data?.payNo,
            payCycle: data?.payCycle,
            driverNumber: data?.driverNumber,
            companyName: data?.companyName,
            email: data?.email,
            primarynumber: data?.primarynumber,
            secondarynumber: data?.secondarynumber,
            switchTypename: data?.switchTypename,
            alphaCode: data?.alphaCode,
            city: data?.city,
            province: data?.province,
            country: data?.country,
            dockName: data?.dockName,
        }
    })

    return (
        <div className="user-role-table">
            <h6>List of Agents/Interliners</h6>
            <DataGrid rows={rows} columns={columns} pageSize={10} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} componentsProps={{
                toolbar: { showQuickFilter: true }
            }} />
        </div>
    );
}
